type TinyMceEditor = {
  getBody: () => HTMLElement;
  on: (event: string, callback: (event?: { content?: string }) => void) => void;
};

function isWhitespaceText(node: Node): boolean {
  return node.nodeType === Node.TEXT_NODE && !(node.textContent ?? '').trim();
}

/** True when a paragraph only wraps image(s) and optional br/whitespace. */
export function isParagraphImageOnly(paragraph: HTMLParagraphElement): boolean {
  let hasImage = false;

  for (const node of Array.from(paragraph.childNodes)) {
    if (isWhitespaceText(node)) continue;

    if (node.nodeType === Node.ELEMENT_NODE) {
      const tag = (node as Element).tagName;
      if (tag === 'BR') continue;
      if (tag === 'IMG') {
        hasImage = true;
        continue;
      }
    }

    return false;
  }

  return hasImage;
}

export function unwrapParagraphsAroundImagesInBody(root: ParentNode): void {
  const paragraphs = Array.from(root.querySelectorAll('p'));

  for (const paragraph of paragraphs) {
    if (!isParagraphImageOnly(paragraph)) continue;

    const parent = paragraph.parentNode;
    if (!parent) continue;

    while (paragraph.firstChild) {
      parent.insertBefore(paragraph.firstChild, paragraph);
    }
    parent.removeChild(paragraph);
  }
}

/** Remove TinyMCE's `<p><img /></p>` wrappers from stored or loaded HTML. */
export function sanitizeImageHtml(html: string): string {
  if (!html || !html.includes('<img')) return html;

  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  unwrapParagraphsAroundImagesInBody(doc.body);
  return doc.body.innerHTML;
}

export function applyEditorImageSanitize(editor: TinyMceEditor): void {
  editor.on('BeforeGetContent', () => {
    unwrapParagraphsAroundImagesInBody(editor.getBody());
  });

  editor.on('BeforeSetContent', event => {
    if (event?.content) {
      event.content = sanitizeImageHtml(event.content);
    }
  });
}
